// extracted by mini-css-extract-plugin
export default {"wrapper":"vi-z","reviewFormSuccess":"wi-z","header":"xi-z","message":"yi-z","paragraph":"zi-z","lottieContainer":"Ai-z"};